/**
 * DevelopmentTabs Component
 * Tab navigation for the 4 development categories with icons
 */

import { Activity, Eye, MessageCircle, Heart } from 'lucide-react';
import type { BabyDevelopmentCategory } from '../types';

const CATEGORY_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  motorik: Activity,
  sinne: Eye,
  kommunikation: MessageCircle,
  sozial: Heart,
};

interface DevelopmentTabsProps {
  categories: BabyDevelopmentCategory[];
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export function DevelopmentTabs({
  categories,
  activeCategory,
  onCategoryChange,
}: DevelopmentTabsProps) {
  return (
    <div className="flex gap-2 overflow-x-auto">
      {categories.map((category) => {
        const Icon = CATEGORY_ICONS[category.slug] || Activity;
        const isActive = activeCategory === category.slug;

        return (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.slug)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-xl transition-all whitespace-nowrap border ${
              isActive
                ? 'bg-pp-orange border-pp-orange text-white'
                : 'bg-[rgba(31,41,55,0.35)] backdrop-blur-[5px] border-white/25 text-white/60 hover:text-white hover:bg-white/10'
            }`}
          >
            <Icon className="w-5 h-5" />
            {isActive && (
              <span className="text-sm font-medium">
                {category.title}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
